import { render, staticRenderFns } from "./CatalogSort.vue?vue&type=template&id=630612a6"
import script from "./CatalogSort.vue?vue&type=script&lang=js"
export * from "./CatalogSort.vue?vue&type=script&lang=js"
import style0 from "./CatalogSort.vue?vue&type=style&index=0&id=630612a6&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630612a6')) {
      api.createRecord('630612a6', component.options)
    } else {
      api.reload('630612a6', component.options)
    }
    module.hot.accept("./CatalogSort.vue?vue&type=template&id=630612a6", function () {
      api.rerender('630612a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrintSuite/CatalogSort.vue"
export default component.exports